import { Component, input } from '@angular/core';

import { MultiStat } from './dashboard-widget.model';
import { accentClasses } from './accent';

@Component({
  selector: 'app-multi-stat-tile',
  standalone: true,
  template: `
    <div
      class="card flex h-full items-stretch rounded-xl border border-surface-200/60 bg-surface-0 dark:border-surface-700/40 dark:bg-surface-900"
    >
      @if (loading()) {
      <div class="flex w-full items-center gap-4 p-5">
        <span class="h-8 w-16 animate-pulse rounded bg-surface-200 dark:bg-surface-700"></span>
      </div>
      } @else {
      @for (s of stats(); track s.label; let last = $last) {
      <div
        class="flex flex-1 items-center justify-between gap-3 p-5"
        [class.border-r]="!last"
        [class.border-surface-200]="!last"
        [class.dark:border-surface-700]="!last"
      >
        <div class="flex min-w-0 flex-col gap-1">
          <span class="text-[10px] font-bold uppercase tracking-wider text-text-muted">{{ s.label }}</span>
          <div class="flex items-baseline gap-1">
            <span class="text-3xl font-extrabold tracking-tight text-text-main">{{ s.value }}</span>
            @if (s.unit) {
            <span class="text-sm font-medium text-text-muted">{{ s.unit }}</span>
            }
          </div>
          @if (s.delta; as d) {
          <span class="flex items-center gap-1 text-xs font-medium" [class]="deltaClass(d)">
            <i [class]="d.direction === 'up' ? 'pi pi-arrow-up' : 'pi pi-arrow-down'" class="text-[0.6rem]"></i>
            <span>{{ d.value }}</span>
            @if (d.label) {
            <span class="text-text-muted/80">{{ d.label }}</span>
            }
          </span>
          }
        </div>
        @if (s.icon) {
        <div class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl" [class]="accentBox(s.accent)">
          <i [class]="s.icon" class="text-lg"></i>
        </div>
        }
      </div>
      }
      }
    </div>
  `,
})
export class MultiStatTileComponent {
  stats = input<MultiStat[]>([]);
  loading = input<boolean>(false);

  accentBox(accent?: string): string {
    return accentClasses(accent ?? '');
  }

  deltaClass(d: NonNullable<MultiStat['delta']>): string {
    switch (d.sentiment) {
      case 'good':
        return 'text-green-600 dark:text-green-400';
      case 'bad':
        return 'text-red-600 dark:text-red-400';
      default:
        return 'text-text-muted';
    }
  }
}
